'use strict';

var _ = require('lodash');
var GlobalNotifPanelController = function GlobalNotifPanelController($scope, $rootScope, $state, globalNotifPanelDataService, constants, momentService, systemConstants, $timeout) {
  var DEFAULT_INTERVAL = 5;
  var NOT_FOUND_CLASS = 'global-notif-not-found-class';
  //$scope.globalNotifTotalNumber = 0;
  callForNotification();
  function updateGrid() {
    globalNotifPanelDataService.getTotalAlertsNumber().then(updateGridData);
  }
  function updateGridData(globalNotifs) {
    if (globalNotifs > 0) {
      $scope.globalNotifTotalNumber = '(' + 1 + ')';
      $scope.data = [{
        name: 'Host Share Available'
      }];
    }
  }
  function getInterval() {
    return DEFAULT_INTERVAL * 600;
  }
  function callForNotification() {
    var interval = getInterval();
    $timeout(function () {
      updateGrid();
      $scope.$broadcast('brush-filter:filterApplied');
      callForNotification();
    }, interval);
  }
  function updatePanelTitle() {
    var mapTitlePrefix = {};
    mapTitlePrefix[constants.GLOBAL_NOTIF_TABS.GLOBAL] = constants.GLOBAL_NOTIF_PANEL_TITLE_PREFIX.GLOBAL;
    mapTitlePrefix[constants.GLOBAL_NOTIF_TABS.CATEGORY2] = constants.GLOBAL_NOTIF_PANEL_TITLE_PREFIX.CATEGORY2;
    $scope.panelTitlePrefix = mapTitlePrefix[$scope.tab];
  }
  function switchGrid(newValue, oldValue) {
    if (newValue !== oldValue) {
      $scope.clearSelection(true);
      updatePanelTitle();
      updateGridData($scope.globalNotifs);
    }
  }
  function hasSelectedRows() {
    return $scope.gridSettings.jqxGrid('selectedrowindexes').length > 0;
  }
  var getCellClassName = function getCellClassName(rowId, datafield) {
    if (datafield === 'name' && $scope.gridSettings.source[rowId].notFound === true) {
      return [NOT_FOUND_CLASS];
    }
    return [];
  };
  $scope.tab = 'globalTab';
  $scope.modeList = [{
    label: 'Global',
    value: constants.GLOBAL_NOTIF_TABS.GLOBAL
  }
  //,{label: 'Category 2', value: constants.GLOBAL_NOTIF_TABS.CATEGORY2}
  ];
  $scope.gridId = 'global-notif-grid';
  $scope.data = [{}];
  $scope.gridSettings = {
    width: '100%',
    height: '100%',
    altrows: true,
    selectionmode: 'checkbox_multiplerowsadvanced',
    source: $scope.data,
    columns: [{
      text: 'Global notifications',
      dataField: 'name',
      cellsalign: 'left',
      textalign: 'left'
      //cellclassname: getCellClassName
    }]
  };
  $scope.navigateButtonVisible = true;
  $scope.panelOpened = false;
  $scope.rowSelectionChanged = function () {
    if ($scope.navigateButtonVisible !== hasSelectedRows()) {
      $scope.navigateButtonVisible = hasSelectedRows();
      $scope.$apply();
    }
  };
  $scope.resetGridPanel = function () {
    $scope.tab = constants.GLOBAL_NOTIF_TABS.GLOBAL;
    updatePanelTitle();
    updateGrid();
  };
  $scope.clearSelection = function (silent) {
    if (silent !== true || hasSelectedRows()) {
      $scope.navigateButtonVisible = false;
      $scope.gridSettings.jqxGrid('clearselection');
    }
  };
  $scope.navigateWithTransitionDataToHstMkt = function () {
    if ($scope.tab === 'globalTab') {
      goToScreen('app.system-configuration');
    } else if ($scope.tab === 'category2Tab') {
      goToScreen('app.system-configuration');
    }
  };
  function goToScreen(screenPath) {
    $scope.hidePanel();
    $state.go(screenPath, {
      transitionData: {
        skipSearch: true,
        // navigationFromGlobalNotif: true,
        'system-configuration:force-tab': {
          tabId: systemConstants.SCREEN_VALUE.SYSTEM_CONFIG.HOST_SHARE
        }
      }
    });
  }
  $scope.$watch('tab', switchGrid);
};
GlobalNotifPanelController.$inject = ['$scope', '$rootScope', '$state', 'GlobalNotifPanelDataService', 'GlobalNotifConstants', 'MomentService', 'SystemConstants', '$timeout'];
module.exports = GlobalNotifPanelController;